import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {TimelineLite} from "gsap";

// #289
export class HHRandomWildStop implements GameRoundPresentation {
    public getAnimation(): TimelineLite {
        // the duration is like this, so that we can see the Random Wilds landing and settled-in in the player's eyes before the first reel stops.
        return new TimelineLite().to({}, 3.5, {});
    }
}